import { loadStripe, Stripe } from '@stripe/stripe-js';

/**
 * Stripe service
 * Handles Stripe initialization and payment intent creation
 */

// Singleton instance of Stripe
let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Get or create Stripe instance
 */
export const getStripe = (): Promise<Stripe | null> => {
  if (!stripePromise) {
    const publishableKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
    if (!publishableKey) {
      console.error('Stripe publishable key is not configured');
      return Promise.resolve(null);
    }
    stripePromise = loadStripe(publishableKey);
  }
  return stripePromise;
};

/**
 * Create a payment intent on the backend
 */
export const createPaymentIntent = async (
  amount: number,
  email: string
): Promise<{ secret: string }> => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL_DEV || '';

  const response = await fetch(backendUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ amount, receipt_email: email }),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(errorResponse.error || 'Failed to create payment intent');
  }

  return response.json();
};
